<template>
  <div class="conver-conf">
    <div class="card-header">
      <span class="title-text">其他配置</span>
    </div>
    <div v-if="adCount.length > 0" class="content-wrap">
      <ul class="form-wrap">
        <el-form :model="formData" :rules="rules" ref="converformRef">
          <li class="form-item" v-if="draft_budgets.bidMode !== 'CPM'">
            <span class="form-label require" style="padding-top: 10px">转化归因 ：</span>
            <el-form-item prop="conversionItems">
              <div class="form-value">
                <el-table :data="formData.conversionItems" style="width: 602px" border size="mini">
                  <el-table-column prop="company" label="广告账户" width="300">
                    <template slot-scope="scope">
                      <div>{{ scope.row.company }}</div>
                      <div>ID：{{ scope.row.accountId }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" label="转化归因" width="300">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.conversionId" placeholder="请选择转化归因" filterable>
                        <el-option
                          v-for="item in tableOptions[scope.row.accountId]"
                          :key="item.conversionId"
                          :label="item.conversionName"
                          :value="item.conversionId"
                          :disabled="item.status === 0"
                        >
                          {{ item.conversionName }}
                          <span style="font-size: 12px;margin-left: 8px" v-if="item.status === 0">({{ item.reason }})</span>
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>
          </li>
          <!-- 头像以及昵称，仅版位选择微信朋友圈展示 -->
          <li class="form-item" v-if="draftAdset.placement && draftAdset.placement.siteSet[0] === 'SITE_SET_MOMENTS'">
            <span class="form-label require" style="padding-top: 10px">头像及昵称 ：</span>
            <el-form-item prop="profileItems">
              <div class="form-value">
                <el-table :data="formData.profileItems" style="width: 602px" border size="mini">
                  <el-table-column prop="company" label="广告账户" width="300">
                    <template slot-scope="scope">
                      <div>{{ scope.row.company }}</div>
                      <div>ID：{{ scope.row.accountId }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" label="头像及昵称" width="300">
                    <template slot-scope="scope">
                      <el-select v-model="scope.row.profileId" placeholder="请选择头像以及昵称" filterable>
                        <el-option
                          v-for="item in profileList[scope.row.accountId]"
                          :key="item.profileId"
                          :label="item.profileName"
                          :value="item.profileId"
                        >
                          <div style="display: flex">
                            <div><img style="width:30px; height:30px" :src="item.headImageUrl" /></div>
                            <div style="magin-left: 12px">{{ item.profileName }}</div>
                          </div>
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>
          </li>
          <!-- 落地页 -->
          <li class="form-item" style="margin-top: 8px">
            <span class="form-label require" style="padding-top: 10px">落地页：</span>
            <div class="form-value">
              <el-alert class="alert" :closable="false" type="warning" show-icon>
                <template #title>
                  跨账户选择的资产将会自动授权至使用账户，详情可查看
                  <a href="/ads_asset_manage/gdt/asset_permissions" class="link" target="_blank">
                    账户资产共享
                  </a>
                </template>
              </el-alert>
              <el-radio-group v-model="formData.landingPage.type" style="margin-top: 12px">
                <el-radio label="ALL">全部相同</el-radio>
                <el-radio label="ACCOUNT">分配到账户</el-radio>
                <el-radio label="TARGETING">分配到定向</el-radio>
                <el-radio label="CREATIVE">分配到创意组</el-radio>
              </el-radio-group>
              <el-form-item prop="landingPage">
                <!-- 落地页-全部相同 -->
                <div style="display: flex;margin-top: 12px" v-if="formData.landingPage.type === 'ALL'">
                  <el-select v-model="formData.landingPage.allContents[0].landType" filterable>
                    <el-option label="蹊径落地页" value="LAND"></el-option>
                    <el-option v-if="promotedObjectType === 'APP_IOS'" label="App Store下载页" value="APP"></el-option>
                  </el-select>
                  <el-popover
                    popper-class="conver-conf-form-preview-popover"
                    trigger="manual"
                    width="181"
                    placement="right-end"
                    :value="visible && previewType === 'ALL'"
                    :visible-arrow="false"
                  >
                    <div class="preview-popover">
                      <iframe :src="previewUrl" class="preview-img" />
                    </div>
                    <div slot="reference">
                      <el-select
                        @visible-change="visible = false"
                        v-if="formData.landingPage.allContents[0].landType === 'LAND'"
                        style="margin-left: 12px;width: 250px"
                        v-model="formData.landingPage.allContents[0].pageId"
                        filterable
                      >
                        <el-option v-for="(item, index) in allLandPageList" :label="item.pageName" :key="index" :value="item.pageId">
                          <span style="float: left">{{ item.pageName }}</span>
                          <span style="float: right; color: #0b75ff; font-size: 13px;margin-left: 6px" @click.stop="viewPage(item, 'ALL')"
                            >预览</span
                          >
                        </el-option>
                      </el-select>
                    </div>
                  </el-popover>
                </div>
                <!-- 落地页-分配到账户 -->
                <div style="margin-top: 12px" v-if="formData.landingPage.type === 'ACCOUNT'">
                  <el-table :data="formData.landingPage.accountContents" style="width: 852px" border size="mini">
                    <el-table-column prop="company" label="广告账户" width="300">
                      <template slot-scope="scope">
                        <div>{{ scope.row.company }}</div>
                        <div>ID：{{ scope.row.accountId }}</div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="xxx" label="落地页" width="550">
                      <template slot-scope="scope">
                        <el-popover
                          popper-class="conver-conf-form-preview-popover"
                          trigger="manual"
                          width="181"
                          placement="right-end"
                          :value="visible && previewType === 'ACCOUNT' && previewId === scope.row.accountId"
                          :visible-arrow="false"
                        >
                          <div class="preview-popover">
                            <iframe :src="previewUrl" class="preview-img" />
                          </div>
                          <div slot="reference" style="display: flex">
                            <el-select v-model="scope.row.landType" filterable>
                              <el-option label="蹊径落地页" value="LAND"></el-option>
                              <el-option v-if="promotedObjectType === 'APP_IOS'" label="App Store下载页" value="APP"></el-option>
                            </el-select>
                            <el-select
                              @visible-change="visible = false"
                              v-if="scope.row.landType === 'LAND'"
                              style="margin-left: 12px"
                              v-model="scope.row.pageId"
                              filterable
                            >
                              <el-option
                                v-for="(item, index) in landPageList[scope.row.accountId]"
                                :label="item.pageName"
                                :key="index"
                                :value="item.pageId"
                              >
                                <span style="float: left">{{ item.pageName }}</span>
                                <span
                                  style="float: right; color: #0b75ff; font-size: 13px;margin-left: 6px"
                                  @click.stop="viewPage(item, 'ACCOUNT', scope.row.accountId)"
                                  >预览</span
                                >
                              </el-option>
                            </el-select>
                          </div>
                        </el-popover>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <!-- 落地页-分配到定向 -->
                <div style="margin-top: 12px" v-if="formData.landingPage.type === 'TARGETING'">
                  <el-table :data="formData.landingPage.targetingContents" style="width: 852px" border size="mini">
                    <el-table-column prop="groupName" label="定向" width="300">
                      <template slot-scope="scope">
                        <div>{{ scope.row.groupName }}</div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="xxx" label="落地页" width="550">
                      <template slot-scope="scope">
                        <el-popover
                          popper-class="conver-conf-form-preview-popover"
                          trigger="manual"
                          width="181"
                          placement="right-end"
                          :value="visible && previewType === 'REDIRECT' && previewId === scope.row.itemId"
                          :visible-arrow="false"
                        >
                          <div class="preview-popover">
                            <iframe :src="previewUrl" class="preview-img" />
                          </div>
                          <div slot="reference" style="display: flex">
                            <el-select v-model="scope.row.landType" filterable>
                              <el-option label="蹊径落地页" value="LAND"></el-option>
                              <el-option v-if="promotedObjectType === 'APP_IOS'" label="App Store下载页" value="APP"></el-option>
                            </el-select>
                            <el-select
                              @visible-change="visible = false"
                              v-if="scope.row.landType === 'LAND'"
                              style="margin-left: 12px"
                              v-model="scope.row.pageId"
                              filterable
                            >
                              <el-option v-for="(item, index) in allLandPageList" :label="item.pageName" :key="index" :value="item.pageId">
                                <span style="float: left">{{ item.pageName }}</span>
                                <span
                                  style="float: right; color: #0b75ff; font-size: 13px;margin-left: 6px"
                                  @click.stop="viewPage(item, 'REDIRECT', scope.row.itemId)"
                                  >预览</span
                                >
                              </el-option>
                            </el-select>
                          </div>
                        </el-popover>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <!-- 落地页-分配到创意组 -->
                <div style="margin-top: 12px" v-if="formData.landingPage.type === 'CREATIVE'">
                  <el-table :data="formData.landingPage.creativeContents" style="width: 852px" border size="mini">
                    <el-table-column prop="company" label="创意组" width="300">
                      <template slot-scope="scope">
                        <div>{{ scope.row.groupName }}</div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="xxx" label="落地页" width="550">
                      <template slot-scope="scope">
                        <el-popover
                          popper-class="conver-conf-form-preview-popover"
                          trigger="manual"
                          width="181"
                          placement="right-end"
                          :value="visible && previewType === 'CREATIVE' && previewId === scope.row.itemId"
                          :visible-arrow="false"
                        >
                          <div class="preview-popover">
                            <iframe :src="previewUrl" class="preview-img" />
                          </div>
                          <div slot="reference" style="display: flex">
                            <el-select v-model="scope.row.landType" filterable>
                              <el-option label="蹊径落地页" value="LAND"></el-option>
                              <el-option v-if="promotedObjectType === 'APP_IOS'" label="App Store下载页" value="APP"></el-option>
                            </el-select>
                            <el-select
                              @visible-change="visible = false"
                              v-if="scope.row.landType === 'LAND'"
                              style="margin-left: 12px"
                              v-model="scope.row.pageId"
                              filterable
                            >
                              <el-option v-for="(item, index) in allLandPageList" :label="item.pageName" :key="index" :value="item.pageId">
                                <span style="float: left">{{ item.pageName }}</span>
                                <span
                                  style="float: right; color: #0b75ff; font-size: 13px;margin-left: 6px"
                                  @click.stop="viewPage(item, 'CREATIVE', scope.row.itemId)"
                                  >预览</span
                                >
                              </el-option>
                            </el-select>
                          </div>
                        </el-popover>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-form-item>
            </div>
          </li>

          <!-- 应用直达URL： -->
          <li
            class="form-item"
            style="margin-top: 8px"
            v-if="draftAdset.placement && draftAdset.placement.siteSet[0] !== 'SITE_SET_MOMENTS'"
          >
            <span class="form-label" style="padding-top: 10px">应用直达URL：</span>
            <div class="form-value">
              <el-radio-group v-model="formData.deepLinkUrl.type" style="margin-top: 12px">
                <el-radio label="ALL">全部相同</el-radio>
                <el-radio label="ACCOUNT">分配到账户</el-radio>
                <el-radio label="TARGETING">分配到定向</el-radio>
                <el-radio label="CREATIVE">分配到创意组</el-radio>
              </el-radio-group>
              <el-form-item prop="deepLinkUrl">
                <!-- 应用直达URL-全部相同 -->
                <div style="display: flex;margin-top: 12px" v-if="formData.deepLinkUrl.type === 'ALL'">
                  <el-input style="width: 400px" v-model="formData.deepLinkUrl.allContents[0].pageUrl" placeholder="请输入URl"></el-input>
                </div>
                <!-- 应用直达URL-分配到账户 -->
                <div style="margin-top: 12px" v-if="formData.deepLinkUrl.type === 'ACCOUNT'">
                  <el-table :data="formData.deepLinkUrl.accountContents" style="width: 852px" border size="mini">
                    <el-table-column prop="company" label="广告账户" width="300">
                      <template slot-scope="scope">
                        <div>{{ scope.row.company }}</div>
                        <div>ID：{{ scope.row.accountId }}</div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="xxx" label="应用直达URL" width="550">
                      <template slot-scope="scope">
                        <el-input style="width: 400px" placeholder="请输入URl" v-model="scope.row.pageUrl"></el-input>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <!-- 应用直达URL-分配到定向 -->
                <div style="margin-top: 12px" v-if="formData.deepLinkUrl.type === 'TARGETING'">
                  <el-table :data="formData.deepLinkUrl.targetingContents" style="width: 852px" border size="mini">
                    <el-table-column prop="groupName" label="定向" width="300">
                      <template slot-scope="scope">
                        <div>{{ scope.row.groupName }}</div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="xxx" label="应用直达URL" width="550">
                      <template slot-scope="scope">
                        <el-input style="width: 400px" v-model="scope.row.pageUrl" placeholder="请输入URl"></el-input>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <!-- 应用直达URL-分配到创意组 -->
                <div style="margin-top: 12px" v-if="formData.deepLinkUrl.type === 'CREATIVE'">
                  <el-table :data="formData.deepLinkUrl.creativeContents" style="width: 852px" border size="mini">
                    <el-table-column prop="company" label="创意组" width="300">
                      <template slot-scope="scope">
                        <div>{{ scope.row.groupName }}</div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="xxx" label="应用直达URL" width="550">
                      <template slot-scope="scope">
                        <el-input style="width: 400px" v-model="scope.row.pageUrl" placeholder="请输入URl"></el-input>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-form-item>
            </div>
          </li>

          <!-- 通用链接URL： -->
          <li class="form-item" style="margin-top: 8px">
            <span class="form-label" style="padding-top: 10px">通用链接URL：</span>
            <div class="form-value">
              <el-radio-group v-model="formData.universalLinkUrl.type" style="margin-top: 12px">
                <el-radio label="ALL">全部相同</el-radio>
                <el-radio label="ACCOUNT">分配到账户</el-radio>
                <el-radio label="TARGETING">分配到定向</el-radio>
                <el-radio label="CREATIVE">分配到创意组</el-radio>
              </el-radio-group>
              <el-form-item prop="universalLinkUrl">
                <!-- 通用链接URL-全部相同 -->
                <div style="display: flex;margin-top: 12px" v-if="formData.universalLinkUrl.type === 'ALL'">
                  <el-input
                    style="width: 400px"
                    v-model="formData.universalLinkUrl.allContents[0].pageUrl"
                    placeholder="请输入URl"
                  ></el-input>
                </div>
                <!-- 通用链接URL-分配到账户 -->
                <div style="margin-top: 12px" v-if="formData.universalLinkUrl.type === 'ACCOUNT'">
                  <el-table :data="formData.universalLinkUrl.accountContents" style="width: 852px" border size="mini">
                    <el-table-column prop="company" label="广告账户" width="300">
                      <template slot-scope="scope">
                        <div>{{ scope.row.company }}</div>
                        <div>ID：{{ scope.row.accountId }}</div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="xxx" label="通用链接URL" width="550">
                      <template slot-scope="scope">
                        <el-input style="width: 400px" v-model="scope.row.pageUrl" placeholder="请输入URl"></el-input>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <!-- 通用链接URL-分配到定向 -->
                <div style="margin-top: 12px" v-if="formData.universalLinkUrl.type === 'TARGETING'">
                  <el-table :data="formData.universalLinkUrl.targetingContents" style="width: 852px" border size="mini">
                    <el-table-column prop="groupName" label="定向" width="300">
                      <template slot-scope="scope">
                        <div>{{ scope.row.groupName }}</div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="xxx" label="通用链接URL" width="550">
                      <template slot-scope="scope">
                        <el-input style="width: 400px" v-model="scope.row.pageUrl" placeholder="请输入URl"></el-input>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <!-- 通用链接URL-分配到创意组 -->
                <div style="margin-top: 12px" v-if="formData.universalLinkUrl.type === 'CREATIVE'">
                  <el-table :data="formData.universalLinkUrl.creativeContents" style="width: 852px" border size="mini">
                    <el-table-column prop="groupName" label="创意组" width="300">
                      <template slot-scope="scope">
                        <div>{{ scope.row.groupName }}</div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="xxx" label="通用链接URL" width="550">
                      <template slot-scope="scope">
                        <el-input style="width: 400px" v-model="scope.row.pageUrl" placeholder="请输入URl"></el-input>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-form-item>
            </div>
          </li>
          <li class="form-item" v-if="draftAdset.placement && draftAdset.placement.siteSet[0] === 'SITE_SET_MOMENTS'">
            <span class="form-label">原生页素材规则：</span>
            <div class="form-value">
              <el-radio-group v-model="formData.overrideCanvasHeadOption">
                <el-radio label="OPTION_CREATIVE_OVERRIDE_CANVAS"> 外层素材覆盖内层顶部素材 </el-radio>
              </el-radio-group>
            </div>
          </li>
        </el-form>
      </ul>
    </div>
    <div v-else>
      <div class="empty-content">
        请先选账户
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getConversionsList, getLandPageList, getProfiles } from "@/api/promotion-gdt.js";
export default {
  data() {
    return {
      formData: {
        conversionItems: [],
        profileItems: [],
        landingPage: {
          type: "ALL",
          allContents: [{ landType: "LAND", pageId: "" }],
          accountContents: [],
          targetingContents: [],
          creativeContents: [],
        },
        deepLinkUrl: {
          type: "ALL",
          allContents: [{ landType: "LAND", pageUrl: "" }],
          accountContents: [],
          targetingContents: [],
          creativeContents: [],
        },
        universalLinkUrl: {
          type: "ALL",
          allContents: [{ landType: "LAND", pageUrl: "" }],
          accountContents: [],
          targetingContents: [],
          creativeContents: [],
        },
        overrideCanvasHeadOption: "OPTION_CREATIVE_OVERRIDE_CANVAS",
      },
      profileList: [],
      rules: {
        conversionItems: [
          {
            trigger: ["change", "blur"],
            validator: (rule, value, callback) => {
              let flag = false;
              value.map((item) => {
                if (!item.conversionId) {
                  flag = true;
                }
              });
              if (flag) {
                callback(new Error("请选择转化归因"));
              } else {
                callback();
              }
            },
          },
        ],
        profileItems: [
          {
            trigger: ["change", "blur"],
            validator: (rule, value, callback) => {
              let flag = false;
              value.map((item) => {
                if (!item.profileId) {
                  flag = true;
                }
              });
              if (flag) {
                callback(new Error("请选择头像及昵称"));
              } else {
                callback();
              }
            },
          },
        ],
        landingPage: [
          {
            trigger: ["change", "blur"],
            validator: (rule, value, callback) => {
              const newData = this.transTypeData(value);
              let flag = false;
              newData.contents.map((item) => {
                if (!item.pageId && item.landType === "LAND") {
                  flag = true;
                }
              });
              if (flag) {
                callback(new Error("请选择落地页"));
              } else {
                callback();
              }
            },
          },
        ],
        // deepLinkUrl: [
        //   {
        //     trigger: ["change", "blur"],
        //     validator: (rule, value, callback) => {
        //       const newData = this.transTypeData(value);
        //       let flag = false;
        //       newData.contents.map((item) => {
        //         if (!item.pageUrl.trim()) {
        //           flag = true;
        //         }
        //       });
        //       if (flag) {
        //         callback(new Error("请填入应用直达URL"));
        //       } else {
        //         callback();
        //       }
        //     },
        //   },
        // ],
        // universalLinkUrl: [
        //   {
        //     trigger: ["change", "blur"],
        //     validator: (rule, value, callback) => {
        //       const newData = this.transTypeData(value);
        //       let flag = false;
        //       newData.contents.map((item) => {
        //         if (!item.pageUrl.trim()) {
        //           flag = true;
        //         }
        //       });
        //       if (flag) {
        //         callback(new Error("请填入通用链接URL"));
        //       } else {
        //         callback();
        //       }
        //     },
        //   },
        // ],
      },
      landPageList: {},
      allLandPageList: [],
      tableOptions: {},
      visible: false,
      previewType: "",
      previewUrl: "",
      previewId: "",
    };
  },
  methods: {
    // 获取转化归因下拉列表previewType
    getOptions() {
      if (this.advertiserIdList.length > 0) {
        this.advertiserIdList.map((item) => {
          getConversionsList({
            accountIds: [item],
            optimizationGoal: this.draft_budgets.optimizationGoal,
            deepBehaviorOptimizationGoal: this.draft_budgets.deepOptimization?.deepOptimizationGoal || null,
            promotedObjectId: this.draftAdset.promotedObjectId || null,
          }).then((res) => {
            this.$set(this.tableOptions, item, res.data);
          });
        });
      }
    },
    // 获取头像一级昵称下拉列表
    getProfilesList() {
      getProfiles({
        promotedObjectType: this.promotedObjectType,
        promotedObjectId: this.draftAdset.promotedObjectId || null,
        accountIds: this.advertiserIdList,
      }).then((res) => {
        this.profileList = res.data;
      });
    },
    // 获取落地页下拉列表
    getLandList(params) {
      this.allLandPageList = [];
      getLandPageList(params).then((res) => {
        this.landPageList = res.data;
        for (const key in res.data) {
          this.allLandPageList = this.allLandPageList.concat(res.data[key]);
        }
      });
    },
    checkData() {
      return new Promise((resolve, reject) => {
        this.$refs.converformRef.validate((valid) => {
          if (valid) {
            resolve();
          } else {
            reject();
          }
        });
      });
    },
    transTypeData(data) {
      const { type, allContents, accountContents, targetingContents, creativeContents } = data;
      const newData = {
        contents: {},
        type,
      };
      switch (type) {
        case "ALL":
          newData.contents = allContents;
          break;
        case "ACCOUNT":
          newData.contents = accountContents;
          break;
        case "TARGETING":
          newData.contents = targetingContents;
          break;
        case "CREATIVE":
          newData.contents = creativeContents;
          break;
      }
      return newData;
    },
    saveInStore() {
      const data = JSON.parse(JSON.stringify(this.formData));
      // 为了回显
      data.originData = JSON.parse(JSON.stringify(this.formData));
      const { landingPage, deepLinkUrl, universalLinkUrl } = data;
      data.landingPage = this.transTypeData(landingPage);
      data.deepLinkUrl = this.transTypeData(deepLinkUrl);
      data.universalLinkUrl = this.transTypeData(universalLinkUrl);
      data.landingPage.contents.map((item) => {
        if (item.landType === "APP") {
          (item.pageId = null), (item.pageType = "DEFAULT");
        } else {
          const findObj = this.allLandPageList.find((child) => child.pageId === item.pageId) || {};
          item.pageType = findObj.pageType;
          item.accountId = item.accountId || findObj.accountId;
        }
        return item;
      });
      if (this.draft_budgets.bidMode === "CPM") {
        data.conversionItems = [];
      }
      if (this.draftAdset.placement?.siteSet[0] !== "SITE_SET_MOMENTS") {
        data.profileItems = [];
        data.overrideCanvasHeadOption = null;
      }
      this.$store.commit("set_draft_extra_config_gdt", data);
    },
    viewPage(record, type, id) {
      this.visible = true;
      this.previewType = type;
      this.previewUrl = record.previewUrl;
      this.previewId = id;
    },
    // 修改账户adcount重新赋值
    changeAdcountGetTableData() {
      this.formData.conversionItems = [];
      this.formData.profileItems = [];
      this.formData.landingPage.accountContents = [];
      this.formData.deepLinkUrl.accountContents = [];
      this.formData.universalLinkUrl.accountContents = [];
      this.adCount.map((item) => {
        this.formData.conversionItems.push({
          accountId: item.advertiserId,
          company: item.company,
          conversionId: "",
        });
        this.formData.profileItems.push({
          accountId: item.advertiserId,
          company: item.company,
          profileId: "",
        });
        this.formData.landingPage.accountContents.push({
          landType: "",
          accountId: item.advertiserId,
          company: item.company,
          pageId: "",
          pageType: "",
        });
        this.formData.deepLinkUrl.accountContents.push({
          accountId: item.advertiserId,
          company: item.company,
          pageUrl: "",
        });
        this.formData.universalLinkUrl.accountContents.push({
          accountId: item.advertiserId,
          company: item.company,
          pageUrl: "",
        });
      });
    },
    // 修改定向重新赋值
    changeTargetGetTableData() {
      this.formData.landingPage.targetingContents = [];
      this.formData.deepLinkUrl.targetingContents = [];
      this.formData.universalLinkUrl.targetingContents = [];
      this.draft_targeting.map((item) => {
        this.formData.landingPage.targetingContents.push({
          landType: "",
          pageId: "",
          pageType: "",
          groupName: item.targetingName,
          itemId: item.itemId,
        });
        this.formData.deepLinkUrl.targetingContents.push({
          groupName: item.targetingName,
          pageUrl: "",
        });
        this.formData.universalLinkUrl.targetingContents.push({
          groupName: item.targetingName,
          pageUrl: "",
        });
      });
    },
    // 修改创意组重新赋值
    changeCreativeGroupGetTableData() {
      this.formData.landingPage.creativeContents = [];
      this.formData.deepLinkUrl.creativeContents = [];
      this.formData.universalLinkUrl.creativeContents = [];
      this.creativeGroupsList.map((item) => {
        this.formData.landingPage.creativeContents.push({
          landType: "",
          pageId: "",
          pageType: "",
          groupName: item.groupName,
          itemId: item.itemId,
        });
        this.formData.deepLinkUrl.creativeContents.push({
          groupName: item.groupName,
          pageUrl: "",
        });
        this.formData.universalLinkUrl.creativeContents.push({
          groupName: item.groupName,
          pageUrl: "",
        });
      });
    },
    // 修改应用ID对落地页表格进行赋值
    changeLandTableData() {
      this.formData.landingPage.allContents[0].pageId = "";
      this.formData.landingPage.accountContents.map((item) => {
        item.pageId = "";
        return item;
      });
      this.formData.landingPage.targetingContents.map((item) => {
        item.pageId = "";
        return item;
      });
      this.formData.landingPage.creativeContents.map((item) => {
        item.pageId = "";
        return item;
      });
    },
  },
  computed: {
    ...mapState({
      adCount: (state) => state.PromotionGdt.adCount || [],
      advertiserIdList: (state) => state.PromotionGdt.advertiserIdList,
      promotedObjectType: (state) => state.PromotionGdt.promotedObjectType,
      draftAdset: (state) => state.PromotionGdt.draft_adset,
      draft_targeting: (state) => state.PromotionGdt.draft_targeting,
      draft_budgets: (state) => state.PromotionGdt.draft_budgets,
      creativeGroupsList: (state) => state.PromotionGdt.draft_creative.creativeGroups,
      draft_extra_config: (state) => state.PromotionGdt.draft_extra_config,
    }),
    changeData() {
      const { optimizationGoal, deepOptimization } = this.draft_budgets;
      const deepOptimizationGoal = deepOptimization?.deepOptimizationGoal || null;
      return {
        advertiserIdList: this.advertiserIdList,
        optimizationGoal,
        deepOptimizationGoal,
        promotedObjectId: this.draftAdset.promotedObjectId || null,
      };
    },
    changeLandParams() {
      var accountIds = this.advertiserIdList;
      var promotedObjectType = this.promotedObjectType;
      var promotedObjectId = this.draftAdset.promotedObjectId || null;
      return { accountIds, promotedObjectType, promotedObjectId };
    },
  },
  watch: {
    changeData: {
      handler(newV, oldV) {
        if (
          newV.advertiserIdList !== oldV.advertiserIdList ||
          newV.optimizationGoal !== oldV.optimizationGoal ||
          newV.deepOptimizationGoal !== oldV.deepOptimizationGoal ||
          newV.promotedObjectId !== oldV.promotedObjectId
        ) {
          this.formData.conversionItems = [];
          this.adCount.map((item) => {
            this.formData.conversionItems.push({
              accountId: item.advertiserId,
              company: item.company,
              conversionId: "",
            });
          });
          this.getOptions();
          this.getProfilesList();
        }
      },
    },
    changeLandParams: {
      handler(newV, oldV) {
        const { accountIds: newAccountIds, promotedObjectId: newId, promotedObjectType: newType } = JSON.parse(JSON.stringify(newV));
        const { accountIds: oldAccountIds, promotedObjectId: oldId, promotedObjectType: oldType } = JSON.parse(JSON.stringify(oldV));
        if (
          !(newAccountIds?.length === oldAccountIds?.length && newAccountIds?.sort().toString() === oldAccountIds?.sort().toString()) ||
          newId !== oldId ||
          newType !== oldType
        ) {
          this.getLandList(newV);
          if (this.adCount.length > 0 && this.draft_targeting.length > 0 && this.creativeGroupsList.length > 0) {
            this.changeLandTableData();
          }
        }
      },
    },
    adCount(val) {
      if (val.length > 0) {
        this.$nextTick(() => {
          this.changeAdcountGetTableData();
        });
      }
    },
    draft_targeting(val) {
      if (val.length > 0) {
        this.$nextTick(() => {
          this.changeTargetGetTableData();
        });
      }
    },
    creativeGroupsList: {
      handler(val) {
        if (val.length > 0) {
          this.$nextTick(() => {
            this.changeCreativeGroupGetTableData();
          });
        }
      },
      deep: true,
      immediate: true,
    },
    draft_extra_config: {
      handler(val) {
        if (val) {
          const storeData = JSON.parse(JSON.stringify(val));
          this.formData = storeData.originData;
        }
      },
    },
  },
};
</script>

<style lang="less" scoped>
.conver-conf {
  padding: 24px;
  margin-top: 16px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .card-header {
    display: flex;
    justify-content: space-between;
    .title-text {
      color: rgba(0, 0, 0, 1);
      font-size: 16px;
      font-weight: bold;
    }
  }
  .empty-content {
    height: 200px;
    font-size: 20px;
    margin-left: 10px;
    color: #818181;
    text-align: center;
    line-height: 200px;
  }
  .content-wrap {
    padding-top: 10px;
    .form-wrap {
      margin: 0px;
      padding: 0px;
      list-style: none;
      .form-item {
        display: flex;
        margin-bottom: 0px;
        .form-label {
          flex-shrink: 0;
          display: inline-block;
          width: 130px;
          text-align: right;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
          &.require::before {
            content: "*";
            color: red;
          }
        }
        .form-value {
          width: 100%;
          padding-top: 2px;
          .alert {
            width: 500px;
            background: #edf4ff;
            color: rgba(0, 0, 0, 0.85);
            /deep/ .el-alert__icon {
              color: #0b75ff;
            }
            .link {
              color: #0b75ff;
              background: transparent;
              text-decoration: none;
              outline: none;
              cursor: pointer;
              -webkit-transition: color 0.2s ease;
              transition: color 0.2s ease;
            }
          }
          /deep/ .el-radio__input.is-checked .el-radio__inner {
            color: rgba(24, 144, 255, 1);
            border-color: rgba(24, 144, 255, 1);
            background: rgba(24, 144, 255, 1);
          }
          /deep/ .el-form-item__error {
            position: relative;
          }
          /deep/ .el-radio__input.is-checked + .el-radio__label {
            color: rgba(24, 144, 255, 1);
          }
          /deep/ .el-input-group__append,
          /deep/ .el-input-group__prepend {
            background-color: #fff;
            color: rgba(0, 0, 0, 0.85);
            padding: 0 10px;
          }
          .el-form-item {
            margin: 0px;
          }
          .link-wrap {
            width: 500px;
            border: 1px solid rgba(0, 0, 0, 0.15);
            margin-top: 12px;
            .link-header {
              height: 44px;
              background-color: rgba(0, 0, 0, 0.02);
              border-bottom: 1px solid rgba(0, 0, 0, 0.15);
              font-size: 14px;
              color: rgba(0, 0, 0, 0.85);
              line-height: 44px;
              padding: 0 16px;
              box-sizing: border-box;
            }
            .link-content {
              font-size: 14px;
              padding: 16px;
              box-sizing: border-box;
              line-height: 22px;
              .link-area {
                word-break: break-all;
                margin: 0px;
              }
            }
          }
        }
      }
    }
    .footer-wrap {
      display: block;
      text-align: right;
    }
  }
}
</style>
<style lang="less">
.conver-conf-form-preview-popover {
  padding: 0 !important;
  width: 181px;
  height: 310px;
  background-color: #000;
  border-radius: 20px;
  padding: 0 !important;
  .preview-popover {
    width: 181px;
    height: 310px;
    top: -250px;
    left: 396px;
    background-color: #000;
    border-radius: 20px;
    .preview-img {
      position: absolute;
      right: 6px;
      top: 6px;
      background-color: #fff;
      border-radius: 20px;
      border: 1px solid #e8e8e8;
      -webkit-transform: scale(0.53);
      transform: scale(0.53);
      -webkit-transform-origin: top right;
      transform-origin: top right;
      height: 558px;
      width: 315px;
    }
  }
}
</style>
